export default "__VITE_ASSET__BlHZptVj__"